import ButtonV2 from "../../../../components/ui/button/v2";
import { Inbox, Plus } from "lucide-react";

interface InterviewFindingsEmptyStateProps {
    onAddInterview?: () => void;
}

const InterviewFindingsEmptyState: React.FC<InterviewFindingsEmptyStateProps> = ({ onAddInterview }) => {
    return (
        <div className="my-4 max-w-2xl mx-auto flex flex-col items-center justify-center p-8 border border-dashed border-[#E5E5E5] rounded-lg">
            <div className="flex items-center justify-center w-12 h-12 border rounded-md mb-4 shadow-sm">
                <Inbox className="w-6 h-6 text-foreground"/>
            </div>
            <h3 className="text-base font-semibold text-[#0A0A0A] mb-2">Add Interviews</h3>
            <p className="text-sm text-[#737373] mb-4 text-center">
                Details from field visits and interviews with related parties can be<br /> managed here
            </p>
            <ButtonV2
                variant="primary"
                size="md"
                className="mt-2"
                onClick={onAddInterview}
                prefix={<Plus className="w-4 h-4" />}
            >
                Add
            </ButtonV2>
        </div>
    );
};

export default InterviewFindingsEmptyState;